import _classCallCheck from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import styled from "../../../styled";
import { Box } from '../../Box';
import { checkChanges } from './checkChanges';
import { footerStyle } from './footerStyle';
import { SubmitButton } from '../components/SubmitButton';
import { ResetButton } from '../components/ResetButton';
import { ChangesCountLabel } from './ChangesCountLabel';
export var SUBMITTED_TRANSITION_DELAY = 700; // slow transition duration on theme

export var SAVED_TRANSITION_DELAY = 100; // superFast transition duration on theme

var StyledFormActionsContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme,
      isFooter = _ref.isFooter,
      isVisible = _ref.isVisible;
  return [isFooter && footerStyle(theme, isVisible)];
});

var isValidStatus = function isValidStatus(isValid, status) {
  return isValid && (!status || !status.hasError);
};

export var FormActionsContainer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FormActionsContainer, _React$PureComponent);

  var _super = _createSuper(FormActionsContainer);

  function FormActionsContainer() {
    var _this;

    _classCallCheck(this, FormActionsContainer);

    _this = _super.apply(this, arguments);
    _this.hideTimeout = null;
    _this.recentlySavedTimeout = null;
    _this.state = {
      currentValues: _this.props.formikProps.initialValues,
      recentlySaved: false
    };

    _this.handleReset = function () {
      var currentValues = _this.state.currentValues;
      var _this$props$formikPro = _this.props.formikProps,
          setValues = _this$props$formikPro.setValues,
          handleReset = _this$props$formikPro.handleReset;
      handleReset();
      setValues(currentValues);
    };

    _this.renderLabel = function (count) {
      return React.createElement(ChangesCountLabel, {
        count: count
      });
    };

    _this.clearTimeouts = function () {
      clearTimeout(_this.hideTimeout);
      clearTimeout(_this.recentlySavedTimeout);
    };

    _this.updateSubmitStatus = function () {
      var _this$props$formikPro2 = _this.props.formikProps,
          isValid = _this$props$formikPro2.isValid,
          status = _this$props$formikPro2.status,
          currentValues = _this$props$formikPro2.values;
      var submittedDelay = _this.props.hideDelay || SUBMITTED_TRANSITION_DELAY;

      _this.setState({
        recentlySaved: true
      });

      _this.clearTimeouts();

      _this.hideTimeout = setTimeout(function () {
        if (isValidStatus(isValid, status)) {
          _this.setState({
            currentValues: currentValues
          });
        }

        _this.recentlySavedTimeout = setTimeout(function () {
          _this.setState({
            recentlySaved: false
          });
        }, SAVED_TRANSITION_DELAY); // wait "hide" delay to update "Save" btn label
      }, submittedDelay);
    };

    return _this;
  }

  _createClass(FormActionsContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasSubmitting = prevProps.formikProps.isSubmitting;
      var isSubmitting = this.props.formikProps.isSubmitting;

      if (wasSubmitting && !isSubmitting) {
        this.updateSubmitStatus();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeouts();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          resetLabel = _this$props.resetLabel,
          submitLabel = _this$props.submitLabel,
          isFooter = _this$props.isFooter,
          showChangesLabel = _this$props.showChangesLabel,
          formikProps = _this$props.formikProps;
      var dirty = formikProps.dirty,
          status = formikProps.status,
          isValidating = formikProps.isValidating,
          isSubmitting = formikProps.isSubmitting,
          isValid = formikProps.isValid,
          values = formikProps.values;
      var _this$state = this.state,
          recentlySaved = _this$state.recentlySaved,
          currentValues = _this$state.currentValues;

      var _checkChanges = checkChanges(currentValues, values),
          hasChanges = _checkChanges.hasChanges,
          changesCount = _checkChanges.changesCount;

      var renderLabelOnLeft = showChangesLabel && isFooter;
      var renderLabelOnRight = showChangesLabel && !isFooter && hasChanges;
      var resetDisabled = !hasChanges || recentlySaved || isValidating || isSubmitting;
      var isFormValid = dirty && isValidStatus(isValid, status);
      return React.createElement(StyledFormActionsContainer, {
        isVisible: hasChanges,
        isFooter: isFooter
      }, renderLabelOnLeft && this.renderLabel(changesCount), React.createElement(SubmitButton, {
        id: id,
        isBusy: isValidating || isSubmitting,
        isValid: isFormValid,
        recentlySaved: recentlySaved
      }, submitLabel), React.createElement(ResetButton, {
        id: id,
        disabled: resetDisabled,
        onClick: this.handleReset
      }, resetLabel), renderLabelOnRight && this.renderLabel(changesCount));
    }
  }]);

  return FormActionsContainer;
}(React.PureComponent);
FormActionsContainer.defaultProps = {
  isValidating: false,
  isSubmitting: false
};